var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#B8C6CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9032 31.6552L38.7806 26.1379H33.5161V22.2759C33.5161 20.731 34.0645 19.5172 36.4774 19.5172H39V14.4414C37.5742 14.2207 36.0387 14 34.6129 14C30.1161 14 26.9355 16.7586 26.9355 21.7241V26.1379H22V31.6552H26.9355V46C29.129 46 31.3226 46 33.5161 46V31.6552H37.9032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b7c84e08b0b89c3fd08dba2271535b96.svg";
export { ForwardRef as ReactComponent };